import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ErrorReportService } from 'src/services/error-report.service';
import { HttpService } from 'src/services/http.service';

@Component({
  selector: 'app-process-list-view-dialog',
  templateUrl: './process-list-view-dialog.component.html',
  styleUrls: ['./process-list-view-dialog.component.scss']
})
export class ProcessListViewDialogComponent implements OnInit {

  form: FormGroup;
  submiting: boolean = false;
  process: any[] = [];

  constructor(
    fb: FormBuilder,
    private http: HttpService,
    private snackbar : MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private errorReport: ErrorReportService,
    private dialogRef: MatDialogRef<ProcessListViewDialogComponent>

  ) { 

    this.form = fb.group({
      leadId: [data.leadID, Validators.required],
      selectedProcess: [ null, Validators.required ],
    });

  }

  ngOnInit(): void {
    this.getProcessList();  
  }

  getProcessList() {
    const user = JSON.parse(localStorage.getItem('token'));
    this.http.save('process_list:list_view', { id: this.data.leadID })
      .subscribe(
        (result: any) => {
          this.process = result.data;
        },
        err => this.errorReport.showMessage(err)
    )
  }

  submit(){
    const isValid = !this.form.invalid;
    const data = this.form.getRawValue();
    
    if (isValid) {
      
      this.http.save('process_list:view_update', { id: data.leadId, process_id: data.selectedProcess, view: true })
      .subscribe(
        (result: any) => {
          if(result.type === 'OK') {
            this.snackbar.open('O Processo Seletivo agora está visível!', 'OK', { duration: 3000 });
            this.dialogRef.close(result);
          } else {
            this.snackbar.open('Desculpe, ocorreu um erro. Tente novamente mais tarde!', 'OK', { duration: 3000 });
          }
        },
        err => this.errorReport.showMessage(err)
      )

    }
  }

}
